<section class="content">
  <div class="container-fluid">
    <form class="col-lg-12" [formGroup]="form">
      <mat-accordion displayMode="flat" [multi]="true">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>General</mat-panel-title>
            <mat-panel-description
              >Name, Tag, Subdomain, Entry route, bciti ID,
              hidden</mat-panel-description
            >
          </mat-expansion-panel-header>
          <section formGroupName="organisation">
            <div class="col-md-12 disabled-field">
              <mat-label>Status</mat-label>
              <br />
              <div>{{ status }}</div>
            </div>
            <mat-form-field class="col-md-12" hintLabel="ex: Vaudreuil-Dorion">
              <mat-label>Name</mat-label>
              <input matInput type="text" formControlName="name" />
            </mat-form-field>
            <mat-form-field class="col-md-12" hintLabel="ex: VAUDREUIL">
              <mat-label>Tag</mat-label>
              <input matInput type="text" formControlName="tag" />
            </mat-form-field>
            <mat-form-field class="col-md-12" [hintLabel]="subdomainHintLabel">
              <mat-label>Subdomain</mat-label>
              <input
                matInput
                type="text"
                formControlName="subdomain"
                placeholder="vaudreuil"
              />
              <mat-error *ngIf="form.value.organisation.subdomain"
                >Subdomain can only contain lowercase letters, numbers or
                dashes.</mat-error
              >
            </mat-form-field>
            <mat-form-field
              class="col-md-12"
              hintLabel="Leave empty for regular homepage entryroute"
            >
              <mat-label>Entry route</mat-label>
              <input matInput type="text" placeholder="TODO" />
            </mat-form-field>
            <div class="col-md-12 disabled-field" *ngIf="bcitiId">
              <mat-label>bciti ID</mat-label>
              <br />
              <div>{{ bcitiId }}</div>
            </div>
            <div class="col-md-12">
              <mat-label>Hidden</mat-label>
              <br />
              <mat-slide-toggle formControlName="hidden"></mat-slide-toggle>
            </div>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="organisation">
          <mat-expansion-panel-header>
            <mat-panel-title>Address</mat-panel-title>
          </mat-expansion-panel-header>
          <section>
            <app-address-card-input
              label="Address"
              formControlName="address"
            ></app-address-card-input>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Logo</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="organisation">
            <div class="col-md-12 logo-section">
              <div *ngIf="!logo" class="org-no-logo col-md-6">
                <i class="far fa-image"></i>
              </div>
              <div *ngIf="logo" class="col-md-6">
                <img [src]="logo" [ngClass]="{ 'user-logo': logo }" />
              </div>
              <div class="col-md-6 logo-upload-button">
                <button mat-raised-button (click)="openInput()">
                  Select File to Upload
                </button>
              </div>
              <input
                id="fileInput"
                hidden
                type="file"
                (change)="fileChange($event.target.files)"
                name="file"
                accept=".jpg,.jpeg,.png,.svg"
              />
            </div>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Geolocation bounds</mat-panel-title>
            <mat-panel-description
              >Center, North East, South West</mat-panel-description
            >
          </mat-expansion-panel-header>
          <section formGroupName="organisation">
            <section formGroupName="bounds">
              <!-- TODO: Add instructions on how to get bounds from openstreetmap -->
              <section formGroupName="center">
                <mat-form-field class="col-md-6">
                  <mat-label>Center - Lattitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lat"
                    placeholder="0"
                  />
                </mat-form-field>
                <mat-form-field class="col-md-6">
                  <mat-label>Center - Longitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lon"
                    placeholder="0"
                  />
                </mat-form-field>
              </section>

              <section formGroupName="northEast">
                <mat-form-field class="col-md-6">
                  <mat-label>North East - Lattitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lat"
                    placeholder="0"
                  />
                </mat-form-field>
                <mat-form-field class="col-md-6">
                  <mat-label>North East - Longitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lon"
                    placeholder="0"
                  />
                </mat-form-field>
              </section>

              <section formGroupName="southWest">
                <mat-form-field class="col-md-6">
                  <mat-label>South West - Lattitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lat"
                    placeholder="0"
                  />
                </mat-form-field>
                <mat-form-field class="col-md-6">
                  <mat-label>South West - Longitude</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="lon"
                    placeholder="0"
                  />
                </mat-form-field>
              </section>
            </section>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Time Zone</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="organisation">
            <mat-form-field class="col-md-1" hintLabel="">
              <mat-label>Time Zone</mat-label>
              <mat-select formControlName="timeZone">
                <mat-option [value]=""></mat-option>
                <mat-option
                  *ngFor="let timezone of timezones"
                  [value]="timezone"
                >
                  {{ timezone }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Map Zoom</mat-panel-title>
            <mat-panel-description>Min, Max, Initial</mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="organisation">
            <section formGroupName="mapZoom">
              <mat-form-field class="col-md-1">
                <mat-label>Min</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="min"
                  placeholder="13"
                />
              </mat-form-field>
              <mat-form-field class="col-md-1">
                <mat-label>Max</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="max"
                  placeholder="20"
                />
              </mat-form-field>
              <mat-form-field class="col-md-1">
                <mat-label>Initial</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="initial"
                  placeholder="15"
                />
              </mat-form-field>
            </section>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Language</mat-panel-title>
            <mat-panel-description>Available, default</mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="platform">
            <section formGroupName="lang">
              <mat-selection-list class="col-md-12" formControlName="available">
                <mat-label>Available languages</mat-label>
                <mat-list-option value="fr" checkboxPosition="before">
                  French
                </mat-list-option>
                <mat-list-option value="en" checkboxPosition="before">
                  English
                </mat-list-option>
              </mat-selection-list>
              <mat-radio-group class="col-md-12" formControlName="default">
                <mat-label>Default language</mat-label>
                <div class="radio-wrap">
                  <mat-radio-button
                    value="fr"
                    [disabled]="!availableLangs.includes('fr')"
                  >
                    French
                  </mat-radio-button>
                  <mat-radio-button
                    value="en"
                    [disabled]="!availableLangs.includes('en')"
                  >
                    English
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </section>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="platform">
          <mat-expansion-panel-header>
            <mat-panel-title>Platform</mat-panel-title>
            <mat-panel-description
              >Req max attachments, print card configuration, ecolocal, dummy
              account</mat-panel-description
            >
          </mat-expansion-panel-header>
          <div class="col-md-12 spacer-top-s">
            <mat-label>Ecolocal</mat-label>
            <br />
            <mat-slide-toggle formControlName="ecolocal"></mat-slide-toggle>
          </div>
          <section formGroupName="request">
            <mat-form-field class="col-md-12">
              <label class="normal-font-weight"
                >Request - Max attachments</label
              >
              <input matInput type="number" formControlName="maxAttachments" />
            </mat-form-field>
          </section>
          <section formGroupName="cardPrint">
            <div class="col-md-12 spacer-top-s">
              <mat-label>Card print - User can print his citizen (or legacy) card</mat-label>
              <br />
              <mat-slide-toggle
                formControlName="canUserPrintCitizenCard"
              ></mat-slide-toggle>
            </div>
            <div class="col-md-12 spacer-top-s">
              <mat-label>Card print - Include card type</mat-label>
              <br />
              <mat-slide-toggle
                formControlName="includeCardType"
              ></mat-slide-toggle>
            </div>
          </section>
          <div class="col-md-12 spacer-top-s">
            <mat-label>Dummy account</mat-label>
            <br />
            <mat-slide-toggle formControlName="dummyAccount"></mat-slide-toggle>
          </div>
          <div class="col-md-12 spacer-top-s">
            <mat-label>Subscribe new user to email notifications</mat-label>
            <br />
            <mat-slide-toggle
              formControlName="emailChannelAutoSubscription"
            ></mat-slide-toggle>
          </div>
          <div class="col-md-12 spacer-top-s mb-4">
            <mat-label>Display Charter of french Language banner for Quebec cities</mat-label>
            <br />
            <mat-slide-toggle
              formControlName="frenchLanguageCharterBanner"
            ></mat-slide-toggle>
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="platform">
          <mat-expansion-panel-header>
              <mat-panel-title>Dashboard</mat-panel-title>
              <mat-panel-description>
                  Dashboard Configuration
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="col-md-12">
              Add dashboard link for cities.<br>
              Expected format: <i>https://charts.mongodb.com/charts-bciti-prod-lfxly/embed/dashboards?id=<strong>DASHBOARD_ID</strong></i> <br>
              Replace <strong>DASHBOARD_ID</strong> by the id of the dashboard you want to display. You can retrieve it on the dashboard url. <br>
              Do not forget to active dashboard module by adding dashboard menu item for admin-side menu of the organization after save.
          </div>
          <mat-selection-list class="d-flex flex-wrap flex-column" formGroupName="dashboardUrl">
              <mat-form-field class="lang-input-wrapper mb-3">
                  <mat-label>Dashboard link FR</mat-label>
                  <input matInput type="text" formControlName="fr" [disabled]="!availableLangs.includes('fr')">
              </mat-form-field>
              <mat-form-field class="lang-input-wrapper mb-3">
                  <mat-label>Dashboard link EN</mat-label>
                  <input matInput type="text" formControlName="en" [disabled]="!availableLangs.includes('en')">
              </mat-form-field>
          </mat-selection-list>
      </mat-expansion-panel>
        
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Modules</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>
          <mat-selection-list formControlName="modules" class="col-md-12">
            <div *ngFor="let module of modules" style="display:flex; flex-direction: column;">
              <mat-list-option
                [value]="module"
                checkboxPosition="before"
              >
                {{ module }}
              </mat-list-option>
              <div formGroupName="platform" class="consultation-provider" *ngIf="module === 'CONSULTATION' && modulesControl.value.includes('CONSULTATION')">
                <div formGroupName="consultation">
                  <mat-radio-group class="col-md-12" formControlName="provider">
                    <div class="consultation-radio-wrap">
                      <mat-radio-button
                        value="BCITI"
                      >
                        BCITI
                      </mat-radio-button>
                      <mat-radio-button
                        value="COCORIKO"
                      >
                        COCORIKO
                      </mat-radio-button>
                      <mat-radio-button
                      value="ZEN_CITY"
                    >
                      Zen City
                    </mat-radio-button>
                    </div>
                  </mat-radio-group>
                
                    <mat-form-field class="consultation-access-type" appearance="standard">
                      <mat-label>Access type</mat-label>
                      <mat-select formControlName="accessType">
                        <mat-option
                          *ngFor="let option of consultationConnectorAccessType"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
              </div>
            </div>
          </mat-selection-list>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Channels</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>
          <mat-selection-list formControlName="channels" class="col-md-12">
            <mat-list-option
              *ngFor="let channel of channels"
              [value]="channel"
              checkboxPosition="before"
            >
              {{ channelLabels[channel] || channel }}
            </mat-list-option>
          </mat-selection-list>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Credentials</mat-panel-title>
            <mat-panel-description>Spreedly</mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="credentials">
            <div formGroupName="spreedly">
              <mat-form-field class="col-md-12">
                <mat-label>Spreedly - Gateway</mat-label>
                <input matInput type="text" formControlName="gateway" />
              </mat-form-field>
            </div>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Feeds</mat-panel-title>
            <mat-panel-description>
              Configuration & Providers
            </mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="feeds">
            <label>Configuration</label>
            <div formGroupName="configuration">
              <div class="col-md-12 disabled-field">
                <mat-label>Classic organisation id</mat-label>
                <br />
                <div>{{ classicId }}</div>
              </div>
              <mat-form-field class="col-md-12">
                <mat-label>Default notification language</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="defaultNoticeLanguage"
                />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Default news language</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="defaultNewsLanguage"
                />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Default news status</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="defaultNewsStatus"
                />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <label class="normal-font-weight">End date days gap</label>
                <input
                  matInput
                  type="number"
                  formControlName="endDateDaysGap"
                />
              </mat-form-field>
              <div class="col-md-12">
                <mat-label class="spacer-top-s"
                  >News language URL interpretation</mat-label
                >
                <br />
                <mat-slide-toggle
                  formControlName="newsLanguageUrlInterpretation"
                ></mat-slide-toggle>
              </div>
              <div class="col-md-12">
                <mat-label class="spacer-top-s">News wordpress feed</mat-label>
                <br />
                <mat-slide-toggle
                  formControlName="newsWordPressFeed"
                ></mat-slide-toggle>
              </div>
              <mat-form-field class="col-md-12">
                <mat-label class="spacer-top-m"
                  >News custom fields item</mat-label
                >
                <mat-chip-list #newsCustomFieldsItemChips>
                  <mat-chip
                    *ngFor="let item of newsCustomFieldItems"
                    (removed)="removeCustomFieldItem(item)"
                  >
                    {{ item }}
                    <mat-button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </mat-button>
                  </mat-chip>
                  <input
                    #newsCustomFieldsItemInput
                    [formControl]="newsCustomFieldsItemCtrl"
                    [matChipInputFor]="newsCustomFieldsItemChips"
                    [matChipInputSeparatorKeyCodes]="matChipSeparatorKeyCodes"
                    (matChipInputTokenEnd)="addCustomFieldItem($event)"
                  />
                </mat-chip-list>
              </mat-form-field>
            </div>
            <label>Providers</label>
            <div formGroupName="providers">
              TODO: Create form element with `url` and `type` attributes that
              can be pushed, sliced from an array
            </div>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Email</mat-panel-title>
            <mat-panel-description>Header, Footer, Logos</mat-panel-description>
          </mat-expansion-panel-header>
          <section formGroupName="email">
            <section formGroupName="header">
              <label>Header: Ville logo</label>
              <div formGroupName="villeLogo">
                <mat-form-field class="col-md-12">
                  <mat-label>URL</mat-label>
                  <input matInput type="text" formControlName="url" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>Height</mat-label>
                  <input matInput type="number" formControlName="height" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>Alt text</mat-label>
                  <input matInput type="text" formControlName="alt" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>Style</mat-label>
                  <input matInput type="text" formControlName="style" />
                </mat-form-field>
              </div>
              <label>Header: bciti logo</label>
              <div formGroupName="bcitiLogo">
                <mat-form-field class="col-md-12">
                  <mat-label>URL</mat-label>
                  <input matInput type="text" formControlName="url" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>height</mat-label>
                  <input matInput type="number" formControlName="height" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>Alt text</mat-label>
                  <input matInput type="text" formControlName="alt" />
                </mat-form-field>
                <mat-form-field class="col-md-12">
                  <mat-label>Style</mat-label>
                  <input matInput type="text" formControlName="style" />
                </mat-form-field>
              </div>
            </section>
            <div formGroupName="footer">
              <label>Footer</label>
              <mat-form-field class="col-md-12">
                <mat-label>Block 1</mat-label>
                <input matInput type="text" formControlName="block1" />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Block 2</mat-label>
                <input matInput type="text" formControlName="block2" />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Block 3</mat-label>
                <input matInput type="text" formControlName="block3" />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Block 4</mat-label>
                <input matInput type="text" formControlName="block4" />
              </mat-form-field>
              <mat-form-field class="col-md-12">
                <mat-label>Block 5</mat-label>
                <input matInput type="text" formControlName="block5" />
              </mat-form-field>
            </div>
          </section>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="actions" *ngIf="displayActions">
        <div class="warning" *ngIf="form.dirty">You have unsaved changes.</div>
        <div>
          <mat-spinner [diameter]="36" *ngIf="loading"></mat-spinner>
        </div>
        <button
          mat-raised-button
          [disabled]="loading || status == DEPLOYED"
          (click)="startOnboarding()"
          color="primary"
        >
          Deploy
        </button>
        <button
          mat-raised-button
          [disabled]="loading"
          (click)="submit()"
          color="primary"
        >
          Save
        </button>
      </div>
    </form>
  </div>
</section>
